const s = {
  name: "Drone",
  dimensions: { width: 40, height: 32 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 32" style="enable-background:new 0 0 40 32;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,4c0-2.2,1.8-4,4-4s4,1.8,4,4h3v2H8v2h24V6h-6V4h3c0-2.2,1.8-4,4-4s4,1.8,4,4h3v2h-6v2h2v2h-4
			c0,3-1.1,5.7-2.8,7.8l2.9,2.9L30.6,22l-2.9-2.9C25.7,20.9,23,22,20,22c-3,0-5.7-1.1-7.8-2.8L9.4,22L8,20.6l2.9-2.9
			C9.1,15.7,8,13,8,10H4V8h2V6H0V4H3z M5,4h4c0-1.1-0.9-2-2-2C5.9,2,5,2.9,5,4z M33,2c-1.1,0-2,0.9-2,2h4C35,2.9,34.1,2,33,2z
			 M15,18.7V13h10v5.7c3-1.7,5-5,5-8.7H10C10,13.7,12,16.9,15,18.7z M17,19.5c0.9,0.3,2,0.5,3,0.5c1,0,2.1-0.2,3-0.5V15h-6V19.5z"/>
		<path class="st0" d="M13.5,25.7c2,0.8,4.2,1.3,6.5,1.3s4.5-0.5,6.5-1.3l-0.8-1.8C24,24.6,22,25,20,25s-4-0.4-5.7-1.1L13.5,25.7z"
			/>
		<path class="st0" d="M20,32c-3,0-5.8-0.6-8.4-1.7l0.8-1.8c2.4,1,4.9,1.5,7.7,1.5s5.3-0.5,7.7-1.5l0.8,1.8C25.8,31.4,23,32,20,32z"
			/>
	</g>
</g>
</svg>
  `
};
export {
  s as Drone
};
